module.exports = __webpack_public_path__ + "img/softgrove-6.208cf91c.jpeg";